import React, { useState, useRef } from "react";
import "../../../style/product.css";
import { InputAdornment } from "@mui/material";

import CancelButton from "../../reusable/Buttons/CancelButton";
import AddButton from "../../reusable/Buttons/AddButton";
import ButtonWithProgress from "../../reusable/Buttons/ButtonWithProgress";
import { calculateTaxAndSalePrice, stopEventPropagation } from "../../../utils/helper";
function AddProductDialog({ onclose, addProduct, buttonloading ,shopCodeError,
  setShopCodeError,
  
}) {
  const [shopData, setShopData] = useState({
    code: "",
    title: "",
    mrp: "",
    basePrice: "",
    taxpercentage:"",
    taxAmount:"",
    saleprice:""
  });
  const [errors, setError] = useState({});
  const productCodeRef = useRef(null);
  const productTitleRef = useRef(null);
  const productMrpRef = useRef(null);
  const productbasepriceRef = useRef(null);
  const productTaxRef=useRef(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setError("")
    setShopCodeError("");
    // let trimmedValue = name === "email" ? value.replace(/\s/g, "") : value.trimStart().replace(/\s+/g, ' ');
    let trimmedValue;
    if (name === "code" || name === "mrp" || name === "baseprice") {
      trimmedValue = value.replace(/\s/g, "");
    } else {
      trimmedValue = value.trimStart().replace(/\s+/g, " ");
    }
    setShopData((prevData) => ({
      ...prevData,
      [name]: trimmedValue,
    }));
    if (name === "shopcode") {
      setShopCodeError("");
    }
  };
  const validateFields = () => {
    let valid = true;
    const newErrors = {};

    if (!shopData.title) {
      newErrors.title = "This field must not be empty. Please enter a value.";
      valid = false;
      productTitleRef.current.focus();
    } else if (!shopData.code) {
      newErrors.code = "This field must not be empty. Please enter a value.";
      valid = false;
      productCodeRef.current.focus();
    } else if (!shopData.mrp) {
      newErrors.mrp = "This field must not be empty. Please enter a value.";
      valid = false;
      productMrpRef.current.focus();
    } else if (!shopData.basePrice) {
      newErrors.basePrice =
        "This field must not be empty. Please enter a value.";
      valid = false;
      productbasepriceRef.current.focus();
    }

    setError(newErrors);
    return valid;
  };
  const handleAdd = () => {
 
    if (!validateFields()) {
      return;
    }
    setShopCodeError("");
    addProduct(shopData);
  };



  const handleBasePriceChange = (event) => {
    const { value } = event.target;

    let sanitizedValue = value.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");

    if (sanitizedValue.length > 12) {
      sanitizedValue = sanitizedValue.slice(0, 12);
    }

    if (parts.length > 2) {
      sanitizedValue = parts[0] + "." + parts.slice(1).join("");
    }

    if (parts.length === 2 && parts[1].length > 2) {
      sanitizedValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }

    // setShopData((prevData) => ({
    //   ...prevData,
    //   basePrice: sanitizedValue,
    // }));
    setShopData((prevData) => {
      const { taxAmount, salePrice } = calculateTaxAndSalePrice(sanitizedValue, prevData.taxpercentage);
  
      return {
        ...prevData,
        basePrice: sanitizedValue,
        taxAmount,
        saleprice: salePrice,
      };
    });
    const mrpValue = parseFloat(shopData.mrp);
    const basePriceValue = parseFloat(sanitizedValue) || 0;

    if (basePriceValue >= mrpValue) {
      setError((prevErrors) => ({
        ...prevErrors,
        basePrice: "*Base price must be less than MRP",
        mrp: "",
      }));
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        saleprice: "",
      }));
    }

    if (mrpValue <= basePriceValue) {
      setError((prevErrors) => ({
        ...prevErrors,
        mrp: "*MRP must be greater than Base price",
      }));
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        mrp: "",
      }));
    }
  };

  const handleMrpChange = (event) => {
    const { value } = event.target;

    let sanitizedValue = value.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");

    if (sanitizedValue.length > 12) {
      sanitizedValue = sanitizedValue.slice(0, 12);
    }

    if (parts.length > 2) {
      sanitizedValue = parts[0] + "." + parts.slice(1).join("");
    }

    if (parts.length === 2 && parts[1].length > 2) {
      sanitizedValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }

    setShopData((prevData) => ({
      ...prevData,
      mrp: sanitizedValue,
    }));

    const basePriceValue = parseFloat(shopData.saleprice);
    const mrpValue = parseFloat(sanitizedValue) || 0;

    if (mrpValue <= basePriceValue) {
      setError((prevErrors) => ({
        ...prevErrors,
        mrp: "*MRP must be greater than Base price",
        basePrice: "",
      }));
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        mrp: "",
      }));
    }

    if (basePriceValue >= mrpValue) {
      setError((prevErrors) => ({
        ...prevErrors,
        basePrice: "*Base price must be less than MRP",
      }));
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        saleprice: "",
      }));
    }
  };
  const handleTaxPercentageChange = (e) => {
    const newTaxPercentage = parseFloat(e.target.value);
    // setShopData((prevData) => ({
    //   ...prevData,
    //   taxpercentage: newTaxPercentage,
    // }));
    
    setShopData((prevData) => {
      const { taxAmount, salePrice } = calculateTaxAndSalePrice(prevData.basePrice, newTaxPercentage);
  
      return {
        ...prevData,
        taxpercentage: newTaxPercentage,
        taxAmount,
        saleprice: salePrice,
      };
    });
  };

  return (
    <div>
      <div className="overlay toggle-icon bc overlay1"></div>
      <div
        className="modal show"
        id="customerModal"
        aria-modal="true"
        role="dialog"
        onClick={onclose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-scrollable"
          onClick={stopEventPropagation}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="modal-content border-0">
            <div className="modal-header">
              <h6 className="modal-title">Add Product</h6>
              <button
                type="button"
                onClick={onclose}
                className="btn-close"
              ></button>
            </div>
            <div className="modal-body">
              <form id="customerForm">
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      autoComplete="off"
                      value={shopData.title}
                      onChange={handleChange}
                      ref={productTitleRef}
                    />
                    {errors.title && (
                      <div className="error-message invalid-feedback">
                        {errors.title}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">
                      Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      name="code"
                      value={shopData.code}
                      onChange={handleChange}
                      ref={productCodeRef}
                    />
                    {errors.code && (
                      <div className="error-message invalid-feedback">
                        {errors.code}
                      </div>
                    )}
                      {shopCodeError && (
                      <div className="error-message invalid-feedback">
                        {shopCodeError}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-4">
                  <label htmlFor="FisrtName" className="form-label">
              Tax(%) <span className="text-danger">*</span>
            </label>
            <select
              name="taxpercentage"
              className="form-control"
              value={shopData.taxpercentage}
              ref={productTaxRef}
              onChange={handleTaxPercentageChange}
             
            >
              <option value="0">0</option>
              <option value="5">5</option>
              <option value="12">12</option>
              <option value="18">18</option>
              <option value="24">24</option>
            </select>
          </div>
                  <div className="col-lg-4">
                    <label className="form-label">
                      MRP <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="mrp"
                      autoComplete="off"
                      placeholder="₹0"
                      value={shopData.mrp}
                      onChange={handleMrpChange}
                      ref={productMrpRef}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            style={{ color: "black" }}
                          >
                            <b>₹</b>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {errors.mrp && (
                      <div className="error-message invalid-feedback">
                        {errors.mrp}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">
                    Base Price
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="baseprice"
                      autoComplete="off"
                      placeholder="₹0"
                      value={shopData.basePrice}
                      onChange={handleBasePriceChange}
                      ref={productbasepriceRef}
                    />
                    {errors.saleprice && (
                      <div className="error-message invalid-feedback">
                        {errors.saleprice}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">
                      Selling Price
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="saleprice"
                      autoComplete="off"
                      placeholder="₹0"
                      value={shopData.saleprice}
                      disabled
                    />
                   
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">
                    Tax Amount
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="saleprice"
                      autoComplete="off"
                      placeholder="₹0"
                      value={shopData.taxAmount}
                   disabled
                     
                    />
                    
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer d-block">
              <CancelButton
                buttonText="Cancel"
                buttonIcon="bx bx-x"
                onClick={onclose}
                additionalClasses="btn-outline-secondary text-left"
              />

              {buttonloading ? (
                <ButtonWithProgress
                  label="Adding...."
                  iconClass="bx bx-plus"
                  buttonClass="btn btn-primary pull-right"
                 
                />
              ) : (
                <AddButton
                  label="Add"
                  iconClass="bx bx-plus"
                  buttonClass="btn btn-primary pull-right"
                  onClick={handleAdd}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProductDialog;
